<template>
    <div>
        <div class="title">
            <div class="bg-color border-bottom">
                <div class="pl10 inline-block ml6" @click.stop>
                    <el-checkbox :value="module.checked" :disabled="isView||module.disabled" @change="val=>changeCurModule(module,val)">
                        <span class="text-bold font14px">{{module.display_name}}</span>
                    </el-checkbox>
                    <CheckAllBtn class="ml20" :data="module" @change="checkAllChange" v-if="!isView"/>


                    <div class="data-dimension-config ml50 inline-block" v-if="['data_query_analysis', 'material_query_analysis'].includes(module.name)&&dataDays=='2'">
                        <span class="font12px">数据日期权限配置：</span>
                        <el-radio-group v-model="module.data_days_global" @change="changeDataDaysGlobal" :disabled="isView">
                            <el-radio label="1">最近
                                <el-input v-model="module.data_days" size="mini" @change="changeDataDays" :disabled="isView||module.data_days_global=='2'" :class="[isInputErr?'input-err':'','mini-input']" style="width: 60px;"></el-input>
                                天</el-radio>
                            <el-radio label="2">不限</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import CheckAllBtn from './checkAllBtn.vue';
    export default {
        name: "CollapseTitle",
        components:{
            CheckAllBtn,
        },
        props: {
            module:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            isView:{
                type: Boolean,
                required:false,
                default:false,
            },
            dataDays:{
                type:[String,Number]
            }
        },
        data(){
            return {
                isInputErr:false,
            }
        },
        methods:{
            checkAllChange(data,val){
                if(this.module.disabled&&this.module.name=='home') return;
                this.$emit('check-all-change',data,val);
            },
            changeCurModule(data,val){
                console.log('changeCurModule',data,val);
                data.checked = val;
                let pid = data.pid;
                if(pid&&pid!=0){
                    this.$emit('check-parents',pid);
                }
                if(val===false){
                    // 模块取消后，取消所有children权限
                    this.checkAllChange(data,false);
                }
            },
            changeDataDaysGlobal(val){
                console.log('changeDataDaysGlobal',val);
                if(val=='2'){
                    this.isInputErr = false;
                    if(this.module.data_days<=0){
                        this.module.data_days = null;
                    }
                }
            },
            changeDataDays(val){
                console.log('changeDataDays',val);
                this.validateDataDays();
            },
            validateDataDays(){
                if(this.module.data_days_global=='2') {
                    this.isInputErr = false;
                }else if(!this.module.data_days){
                    this.$message.error('数据日期天数不可为空');
                    this.isInputErr = true;
                }else if(isNaN(this.module.data_days)){
                    this.$message.error('数据日期天数格式不正确');
                    this.isInputErr = true;
                }else if(this.module.data_days>1000){
                    this.$message.error('数据日期天数不能大于1000天');
                    this.isInputErr = true;
                }else if(parseInt(this.module.data_days)!=this.module.data_days){
                    this.$message.error('数据日期天数请填写整数');
                    this.isInputErr = true;
                }else if(this.module.data_days<=0){
                    this.$message.error('数据日期天数需大于0');
                    this.module.data_days = null;
                    this.isInputErr = true;
                }else{
                    this.isInputErr = false;
                }

            },
        }
    }
</script>

<style lang="scss" scoped>
    .icon-caret {
        transition: all .5s;
        font-size: 18px;
        margin-top: -2px;
    }


    .check-btn{
        color: #808695;
        &:hover{
            color: #17233d;
        }
    }

    ::v-deep .input-err .el-input__inner{
        border-color: #F56C6C!important;
    }

    .bg-color{
        background-color: #f2f2f2;
    }
    .border-bottom{
        border-bottom: solid 1px #d7d7d7;
    }

    .mini-input ::v-deep input.el-input__inner{
        height: 24px;
        line-height: 24px;
    }
</style>
